var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpandLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.083 25.083-1.5-1.5L20 14.167l9.417 9.375-1.5 1.5L20 17.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpandLess);
export default __webpack_public_path__ + "static/media/icon-expand-less.39a445ce02a496003b8e9c9d5a5a62a4.svg";
export { ForwardRef as ReactComponent };